'use client';

import { c as _c } from "react/compiler-runtime";
import AmplitudeProvider from '@eversports/amplitude-react/AmplitudeProvider';
import { b2cAmplitudeConfig } from '@eversports/amplitude-react/core/presets';
export default function CustomAmplitudeProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = b2cAmplitudeConfig({
      apiKey: process.env.NEXT_PUBLIC_AMPLITUDE_PROJECT_API_KEY
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <AmplitudeProvider config={t1}>{children}</AmplitudeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}